import { generateTrackSegmentId } from '@com/components/timeline-panel/utils/generate-id'
import { durationToFrames } from '@com/components/timeline-panel/utils/frame'
import {
  IvAsset,
  IvAssetAudio,
  IvAssetOther,
  IvAssetVideo,
  IvSegmentAudio,
  IvSegmentBase,
  IvSegmentFreeze,
  IvSegmentHand,
  IvSegmentHold,
  IvSegmentImage,
  IvSegmentLoop,
  IvSegmentText,
  IvSegmentVideo,
} from '../types'
import { IvAssetType, IvLoopSubType, IvSegmentType } from '../enums'

// 互动定格默认时长
export const IV_FREEZE_DURATION = 500
// 互动定格默认时长
export const IV_DURATION = 3000
// 手势默认时长
export const HAND_DURATION = 3000
// 文本默认时长
export const TEXT_DURATION = 3000
// 图片默认时长
export const IMAGE_DURATION = 3000

function resolveIvSegmentBase(): IvSegmentBase {
  return {
    id: generateTrackSegmentId().toString(),
    theme: 'video',
    styles: undefined,
    is: undefined,
    trackId: '',

    start: 0,
    frames: 0,
    materialFrames: undefined,
    trimStart: undefined,

    selected: false,
    disabled: false,

    behavior: {},

    type: IvSegmentType.Video,
    sceneUuid: '',
    groupId: '',
  }
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function resolveIvSegment(asset: IvAsset) {
  if (asset.type === IvAssetType.Video) {
    return resolveIvSegmentVideo(asset)
  } else if (asset.type === IvAssetType.Audio) {
    return resolveIvSegmentAudio(asset)
  }

  return resolveIvSegmentImage(asset)
}

export function resolveIvSegmentVideo(asset?: IvAssetVideo): IvSegmentVideo {
  const base = resolveIvSegmentBase()

  const frames = Math.floor(durationToFrames(asset?.duration ?? 500, false))

  return {
    ...base,
    type: IvSegmentType.Video,
    theme: 'video',
    asset: asset ?? null,
    frames,
    materialFrames: frames,
    trimStart: 0,
    // 默认是视频，而不是结束页
    isEnd: false,
  }
}

export function resolveIvSegmentAudio(asset: IvAssetAudio): IvSegmentAudio {
  const base = resolveIvSegmentBase()

  const frames = Math.floor(durationToFrames(asset?.duration ?? 0, false))

  return {
    ...base,
    type: IvSegmentType.Audio,
    theme: 'audio',
    asset: asset ?? null,
    frames,
    materialFrames: frames,
    trimStart: 0,
  }
}

export function resolveIvSegmentImage(asset: IvAssetOther): IvSegmentImage {
  const base = resolveIvSegmentBase()

  return {
    ...base,
    type: IvSegmentType.Image,
    theme: 'image',
    asset: asset ?? null,
    frames: durationToFrames(IMAGE_DURATION),
  }
}

export function resolveIvSegmentText(): IvSegmentText {
  const base = resolveIvSegmentBase()

  return {
    ...base,
    type: IvSegmentType.Text,
    theme: 'text',
    frames: durationToFrames(TEXT_DURATION),
    text: '',
  }
}
export function resolveIvSegmentHand(): IvSegmentHand {
  const base = resolveIvSegmentBase()

  return {
    ...base,
    type: IvSegmentType.Hand,
    frames: durationToFrames(HAND_DURATION),
  }
}

export function resolveIvSegmentFreeze(): IvSegmentFreeze {
  const base = resolveIvSegmentBase()

  return {
    ...base,
    type: IvSegmentType.Freeze,
    frames: durationToFrames(IV_FREEZE_DURATION),
    is: 'gap',
    isEnd: false,
    uuids: [],
  }
}
export function resolveIvSegmentLoop(): IvSegmentLoop {
  const base = resolveIvSegmentBase()

  return {
    ...base,
    type: IvSegmentType.Loop,
    frames: durationToFrames(IV_DURATION),
    isEnd: false,
    uuids: [],
    loopSubType: IvLoopSubType.Single,
  }
}
export function resolveIvSegmentHold(): IvSegmentHold {
  const base = resolveIvSegmentBase()

  return {
    ...base,
    type: IvSegmentType.Hold,
    frames: durationToFrames(IV_DURATION),
    isEnd: false,
    uuids: [],
  }
}
